import { ApolloCache } from '@apollo/client';
import { QueryKeys } from './keys';

export const clearCacheByKey = (cache: ApolloCache<any>, cacheKey: QueryKeys) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: cacheKey,
  });
  cache.gc();
};
